/** W16 GOT Data & Result Update → Review (manual p260). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { GotReviewPage } from "@/features/got/components/review-pages";

export const Route = createFileRoute("/_app/quality/got/review/$sampleId")({
  beforeLoad: () => {
    if (!useAuth.getState().can("got.review")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { sampleId } = Route.useParams();
  return <GotReviewPage sampleId={Number(sampleId)} />;
}
